import { type PrimitiveAtom, useAtom } from 'jotai'
import React from 'react'

import { type ResultViewerType } from '~/utils'

import {
  ResultViewerSwitcherInner,
  type ResultViewerSwitcherInnerProps,
} from './ResultViewerSwitcherInner'

export type ResultViewerSwitcherProps = Pick<
  ResultViewerSwitcherInnerProps,
  'disabled'
> & {
  'data-testid'?: string
  resultViewerTypeAtom: PrimitiveAtom<ResultViewerType>
}

export const ResultViewerSwitcher = ({
  'data-testid': dataTestId = 'components-features-result-viewer-switcher',
  resultViewerTypeAtom,
  ...rest
}: ResultViewerSwitcherProps) => {
  const [resultViewerType, setResultViewerType] = useAtom(resultViewerTypeAtom)

  return (
    <ResultViewerSwitcherInner
      {...rest}
      data-testid={dataTestId}
      value={resultViewerType}
      onChange={setResultViewerType}
    />
  )
}
